import { reaction } from '../../utils/preact-utils';
import { getVideoSizesHandlerStrategy } from '../../../../formats/video-sdk3/lib/strategies/video-sizes-handler/video-sizes-handler-factory';
import { RootStore } from '../../stores/root.store';
import { VideoStore } from '../video.store';
import { VideoSizesHandlerStrategy } from '../../../../formats/video-sdk3/lib/strategies/video-sizes-handler/video-sizes-handler-strategy';

export class VideoSizesHandler {
  videoStore: VideoStore;
  videoSizesHandlerStrategy: VideoSizesHandlerStrategy;

  constructor({ videoStore, analyticsStore }: RootStore) {
    this.videoStore = videoStore;
    this.videoSizesHandlerStrategy = getVideoSizesHandlerStrategy(
      this.videoStore,
      analyticsStore
    );

    this.setupStoreObservers();
  }

  setupStoreObservers(): void {
    reaction(
      () => [this.videoStore.hasVideoStarted.value, this.videoStore.videoSizes],
      ([hasVideoStarted, videoSizes]: [boolean, any]) => {
        if (!hasVideoStarted) {
          return;
        }
        this.videoSizesHandlerStrategy.reactToSizes(videoSizes);
      }
    );
  }
}
